// pages/CompleteProfile.js
import React, { useState ,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert
} from '@mui/material';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const CompleteProfile = () => {
  const [formData, setFormData] = useState({
    age: '',
    sex: '',
    user_phone: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { user, updateUser , needsProfileCompletion } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if(!needsProfileCompletion) {
       navigate('/');         
    }
  },[user]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.put('/auth/complete-profile', formData);
      updateUser(response.data.user);
      navigate('/'); // Redirect to home after successful update
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom align="center">
          أكمل ملفك الشخصي
        </Typography>
        
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
          يرجى تقديم بعض المعلومات الإضافية لاستكمال حسابك.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="normal"
            label="العمر"
            type="number"
            name="age"
            value={formData.age}
            onChange={handleChange}
            required
            inputProps={{ min: 1, max: 120 }}
          />

          <FormControl fullWidth margin="normal" required>
            <InputLabel>الجنس</InputLabel>
            <Select
              name="sex"
              value={formData.sex}
              label="الجنس"
              onChange={handleChange}
            >
              <MenuItem value="male">ذكر</MenuItem>
              <MenuItem value="female">انثى</MenuItem>
            </Select>
          </FormControl>

          <TextField
            fullWidth
            margin="normal"
            label="رقم الهاتف"
            name="user_phone"
            value={formData.user_phone}
            onChange={handleChange}
            required
            placeholder="e.g +201212183998"
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 3 }}
            disabled={loading}
            size="large"
          >
            {loading ? 'جار التحديث ...' : 'إكمال الحساب'}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default CompleteProfile;